import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginThemeService {

  serverUrl = localStorage.getItem('env') ? localStorage.getItem('env') : environment.serverUrl;

  constructor(private http: HttpClient) { }

  getHeader() {
    const authToken = localStorage.getItem('authToken');
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
      })
    };
    return httpOptions;
  }

  getFileHeader() {
    const authToken = localStorage.getItem('authToken');
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${authToken}`,
      })
    };
    return httpOptions;
  }

  getCustomerLoginTheme() {
    return this.http.post(`${this.serverUrl}/customer/distribution`, {}, this.getHeader())
      .pipe(map(response => response));
  }

  uploadLogo(logo) {
    return this.http.post(`${this.serverUrl}/upload/image`, logo, this.getFileHeader())
      .pipe(map(response => response));
  }

  saveLoginScreenTheme(data) {
    return this.http.post(`${this.serverUrl}/distribution`, data, this.getHeader())
    .pipe(map(response => response));
  }
}
